import clsx from "clsx";

// Document with a check mark — Samtycken menu item (same stroke style as
// PaperPlane).
const ConsentIcon = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    style={{ fill: "none" }}
    className={clsx("w-8 h-8", className)}
    {...props}
  >
    <path
      d="M14 2.5H6.5C5.67 2.5 5 3.17 5 4V20C5 20.83 5.67 21.5 6.5 21.5H17.5C18.33 21.5 19 20.83 19 20V7.5L14 2.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M14 2.5V7.5H19"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M8.75 14.25L11 16.5L15.25 12"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default ConsentIcon;
